/**
 * Created by Fernando Torres on 01/02/2018.
 */
import PeriodsListView from '@/views/app/periods/periods-list-view'
import PeriodsCreateView from '@/views/app/periods/periods-create-view'
import PeriodsEditView from '@/views/app/periods/periods-edit-view'
import store from '@/store'

export default [
  {
    path: 'periods',
    name: 'periods',
    component: PeriodsListView,
    beforeEnter (to, from, next) {
      store.dispatch('periods/query', to.query).then((response) => {
        next()
      }).catch(error => {
        console.log(error)
      })
    },
    children: [
      {
        path: 'create',
        name: 'periods-create',
        component: PeriodsCreateView
      },
      {
        path: ':id',
        name: 'periods-edit',
        component: PeriodsEditView
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/app/periods/index.js